import { createContext } from "react";

const MultiSelectContext = createContext<any>({})
MultiSelectContext.displayName = 'MultiSelectContext'

export default MultiSelectContext